var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M123.172,47.905c-1.065-2.685-2.9-5-5.275-6.64c-2.375-1.645-5.185-2.55-8.07-2.6l-22.74-3.315l-10.155-20.57\r\n\tc-0.94-2.735-2.67-5.135-4.97-6.885c-2.3-1.755-5.065-2.79-7.955-2.97c-2.885,0.18-5.65,1.21-7.945,2.96\r\n\tc-2.3,1.75-4.03,4.14-4.965,6.875l-10.165,20.59l-22.74,3.305c-2.895,0.05-5.71,0.955-8.09,2.6c-2.375,1.65-4.215,3.965-5.275,6.655\r\n\tc-0.72,2.805-0.59,5.76,0.37,8.495c0.96,2.73,2.705,5.115,5.02,6.855l16.425,16.02l-3.885,22.62c-0.61,2.345-0.685,4.8-0.215,7.18\r\n\tc0.465,2.375,1.465,4.62,2.92,6.56c2.385,2.33,5.505,3.75,8.83,4.02c3.32,0.27,6.63-0.63,9.36-2.545l20.346-10.69l20.31,10.66\r\n\tc2.82,1.59,5.985,2.47,9.22,2.565c1.7,0.04,3.395-0.3,4.95-0.99c1.555-0.69,2.94-1.72,4.05-3.01c1.455-1.935,2.45-4.17,2.925-6.545\r\n\tc0.47-2.375,0.4-4.825-0.205-7.165l-3.88-22.66l16.43-16.02c2.315-1.745,4.055-4.13,5.015-6.865\r\n\tC123.767,53.661,123.892,50.711,123.172,47.905L123.172,47.905z"}));
}

Star.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 128 128","version":"1.1"};

module.exports = Star;

Star.default = Star;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/star.svg
// module id = 423
// module chunks = 0